//import router from '@/router/index.js';
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  setDivision(context, payload) {
    context.commit('setDivision', payload.value);
  },
  async getDivisions(context, payload) {
    // console.log(context);
    //console.log(payload);

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions');

    if (typeof payload.page !== 'undefined') {
      fetchUrl.searchParams.set('_page', payload.page);
    }

    if (typeof payload.limit !== 'undefined') {
      fetchUrl.searchParams.set('_limit', payload.limit);
    }

    if (typeof payload.offset !== 'undefined') {
      fetchUrl.searchParams.set('_offset', payload.offset);
    }

    if (typeof payload.sort !== 'undefined') {
      let sortString = '';
      Object.keys(payload.sort).forEach(function (item) {
        if (payload.sort[item].active) {
          sortString += item + ':' + payload.sort[item].order + ',';
        }
      });

      if (sortString !== '') {
        fetchUrl.searchParams.set('_sort', sortString.slice(0, -1));
      }
    }

    if (typeof payload.filters !== 'undefined') {
      let filtersString = '';
      payload.filters.forEach((element) => {
        if (element.name === 'state' || element.name === 'locked' || element.name === 'deleted') {
          if (element.value === true) {
            filtersString += element.name + ':1,';
          } else {
            filtersString += element.name + ':0,';
          }
        } else {
          filtersString += element.name + ':' + element.value + ',';
        }
      });

      if (filtersString !== '') {
        fetchUrl.searchParams.set('_filter', filtersString.slice(0, -1));
      } else {
        fetchUrl.searchParams.set('_filter','state:1;0,locked:1;0,deleted:1;0');
      }
    }

    // console.log(fetchUrl.href);

    const config = {
      method: 'get',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      }
    };

    const response = await axios(config);

    //console.log(response);

    return response;
  },
  async getDivisionsForSearch(context) {
    // console.log(context);
    //console.log(payload);

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions?_limit=all');

    const config = {
      method: 'get',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      }
    };

    const response = await axios(config);
    return response;
  },
  async cloneDivision(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-divisions-clone-areyousure'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions/' + payload.uuid + '/clone');
      const config = {
        method: 'post',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async deleteDivision(context, payload) {
    const userResponse = await Swal.fire({
      title: payload.i18n('t-divisions-delete-areyousure'),
      text: payload.i18n('t-divisions-delete-confirm'),
      showCancelButton: true,
      confirmButtonColor: '#1367c8',
      confirmButtonText: payload.i18n('t-yes'),
      cancelButtonColor: '#0ab39c',
      cancelButtonText: payload.i18n('t-cancel')
    });
    if (userResponse.isConfirmed) {
      let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions/' + payload.uuid);
      const config = {
        method: 'delete',
        url: fetchUrl.href,
        headers: {
          //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + context.rootState.authentication.userToken
        }
      };
      const response = await axios(config);
      return response;
    } else {
      return false;
    }
  },
  async getDivisionByUuid(context, payload) {
    //console.log(context);
    //console.log(payload);

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions/' + payload.uuid);

    //console.log(fetchUrl.href);

    const config = {
      method: 'get',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      }
    };

    const response = await axios(config);
    return response;
  },
  async updateDivision(context, payload) {
    //console.log(context);
    //console.log(payload);

    if (typeof payload.state !== 'undefined') {
      if (payload.state === true) {
        payload.state = 1;
      } else {
        payload.state = 0;
      }
    }

    if (typeof payload.locked !== 'undefined') {
      if (payload.locked === true) {
        payload.locked = 1;
      } else {
        payload.locked = 0;
      }
    }

    if (typeof payload.deleted !== 'undefined') {
      if (payload.deleted === true) {
        payload.deleted = 1;
      } else {
        payload.deleted = 0;
      }
    }

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/divisions/' + payload.uuid);

    const config = {
      method: 'put',
      url: fetchUrl.href,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      },
      data: payload
    };

    const response = await axios(config);

    return response;
  },
  async uploadDivisionLogo(context, payload) {
    //console.log(context);
    //console.log(payload.properties);

    let formData = new FormData();
    formData.append('name', payload.name);
    formData.append('folder', payload.folder);
    formData.append('asset', payload.asset);

    let fetchUrl = new URL(process.env.VUE_APP_APIURL + '/clouds/aws/s3/upload');

    const config = {
      method: 'post',
      url: fetchUrl.href,
      data: formData,
      headers: {
        //'x-studiocast-apikey': process.env.VUE_APP_APIKEY,
        //'Content-Type': 'application/json',
        'Content-Type': 'multipart/form-data',
        //'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + context.rootState.authentication.userToken
      },
      // transformRequest: (data, error) => {
      //   console.log(data);
      //   console.log(error);
      //   return formData;
      // },
      onUploadProgress: (progressEvent) => {
        // use upload data, since it's an upload progress
        // iOS: {"isTrusted": false, "lengthComputable": true, "loaded": 123, "total": 98902}
        //setlogoUploadPercentage(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)));
        //console.log(percent);
        context.commit('setlogoUploadPercentage', { value: parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100)) });
      }
    };

    const response = await axios(config);

    return response;
  }
};
